export default {
  getSidebar : (state) => { return state.sidebar; },
  getAutoPrint : (state) => { return JSON.parse(state.autoPrint); },
  getNextoreProducts: (state) => {
    return state.nextoreProducts;
  },
}
